import { useState } from "react";
import { Outlet, useLocation, useNavigate, useRouteLoaderData, useSearchParams, Link } from "react-router-dom";
import UserInfo from "src/components/common/userInfo";
import { useAuthStore, User } from "src/components/main/authStore";
import {
    myAxios, 
    scroll, 
} from "src/components/common/functions";
import { TimeOff } from "./types";
import ServerFooter from "../common/ServerFooter";
export const extraFields = ["page", "limit", "createdAtFrom", "createdAtTo"];
export default function TimeOffList(){
    /*
    const statusColorCode = (status: Status) => {
        switch(status){
            case "Submitted":
                return "black";
            case "Re-Submitted":
                return "purple";
            case "Approved":
                return "green";
            case "Rejected":
                return "gray";
            default:
        }
    }
    */
    const [searchParams, setSearchParams] = useSearchParams();
    const user = useAuthStore(state => state.user) as User;
    const { timeOffs, start: defaultStartDate, end: defaultEndDate, total }:{ timeOffs: TimeOff[], start: string, end: string, total: number } = useRouteLoaderData("TimeOffList")!;
    const [startDate, setStartDate] = useState(defaultStartDate);
    const [endDate, setEndDate] = useState(defaultEndDate);
    const navigate = useNavigate();
    const location = useLocation();
    const filterTimeOffs = timeOffs?.map((u:TimeOff) => ({
        ...u, 
        requestDates: u.fromDate === u.toDate?u.fromDate:u.fromDate + " ~ " + u.toDate, 
        updatedAt: u.updatedAt ?? ""
    }));
    const onFilter = [...searchParams.keys()].filter(param => !extraFields.includes(param)).length > 0;
    return(
        <div className = "cssContent pb8rem">
            <nav className = "my-3">
                <span children = "Submission Date Range" className = "me-2 fw-bold"/>
                <label children = "Start" htmlFor = "startDate" className = "text-nowrap me-2 mb-0"/>
                <input
                    type = "date" 
                    id = "startDate" 
                    name = "startDate" 
                    className = "form-control inline me-3" 
                    value = {startDate} 
                    max = {endDate}
                    onChange = {e => setStartDate(e.currentTarget.value)}
                />
                <label children = "End" htmlFor = "endDate" className = "text-nowrap me-2 mb-0"/>
                <input 
                    type = "date" 
                    id = "endDate" 
                    name = "endDate" 
                    className = "form-control inline me-3" 
                    value = {endDate} 
                    min = {startDate}
                    onChange = {e => setEndDate(e.currentTarget.value)}
                />
                <button
                    children = "Load"
                    disabled = {defaultStartDate === startDate && defaultEndDate === endDate}
                    type = "button"
                    value = "load"
                    id = "load"
                    className = "form-control inline me-5"
                    onClick = {e => {
                        const params = new URLSearchParams(searchParams);
                        params.set("createdAtFrom", startDate);
                        params.set("createdAtTo", endDate);
                        setSearchParams(params, { replace: false });  
                    }}
                />
                <Link children = "Balance Form" className = "btn btn-outline-primary pointer text-nowrap" to = {{pathname: "BalanceForm", search: location.search}} replace/>
                <Link className = {"btn btn-outline-primary pointer ms-3 position-relative"} to = {{ pathname: "Filter", search: location.search }} replace>
                    Filter
                   {onFilter?<span children = "on" className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle" style = {{minWidth: "2.2em"}}/>:null}
                </Link>
                <Link children = "Export" className = "btn btn-outline-primary pointer ms-3" to = {{ pathname: "Export", search: location.search }}/>
                <Link children = "Add" className = "btn btn-outline-primary pointer ms-3" to = "Add"/>
            </nav>
            {!filterTimeOffs.length?<div className = "cssLoading">Empty</div>:
            <div className = "table-responsive">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th>Id</th>
                            <th>Name</th>
                            <th>Department</th>
                            <th>Request Dates</th>
                            <th>Type</th>
                            <th>Submitted On</th>
                            <th>Approver</th>
                            <th>Status</th>
                            {user.timeOffs === "editAll"?
                            <th/>
                            :null}
                            <th/>
                        </tr>
                    </thead>
                    <tbody>
                        {timeOffs.map((timeOff, key) => 
                        <tr key = {key}>
                            <td>{timeOff.id}</td>
                            <td>
                                <UserInfo 
                                    name = {timeOff.requesterName}
                                    id = {timeOff.requesterId}
                                />
                            </td>
                            <td>{timeOff.department}</td>
                            <td>
                                <div>{timeOff.requestDates}</div>
                                <div className = "fw-bold">
                                    Total: <span className = "text-success">{timeOff.totalHours} hours</span>
                                </div>
                            </td>
                            <td>{timeOff.type}</td>
                            <td>{timeOff.createdAt}</td>
                            <td>
                                <UserInfo 
                                    name = {timeOff.approverName}
                                    id = {timeOff.approverId}
                                />
                            </td>
                            <td>{timeOff.status}</td>
                            {user.timeOffs === "editAll"?
                            <td>
                                <button type = "button" className = {!timeOff.paid?"btn btn-primary":"btn btn-info"}
                                    onClick = {async() => {
                                        const formData = new FormData();
                                        formData.append("id", String(timeOff.id));
                                        formData.append("paid", !timeOff.paid?"yes":"");
                                        const res = await myAxios({ fileName: "timeOffs/paidTimeOff.php", formData: formData })
                                        if(!res) return;
                                        /*
                                        setTimeOffs(timeOffs => timeOffs.map(dO => dO.id === timeOff.id?{
                                            ...dO, 
                                            "paid": timeOff.paid
                                        }:dO));
                                        */
                                        navigate(`/TimeOffs`, { replace: true });
                                        scroll(null);
                                    }}
                                >{!timeOff.paid?<>Mark</>:<>Unmark</>}</button>
                            </td>
                            :<></>}
                            <td><Link children = "Detail" to = {String(timeOff.id)} className = "btn btn-outline-primary"/></td>
                        </tr>)}
                    </tbody>
                </table>
            </div>}
            {total?
            <ServerFooter
                length = {total}
            />
            :null}
            <Outlet/>
        </div>
    )
}
